import React from 'react';
import FilterType from './FilterType.jsx';

function FilterGroupContent({filterGroup, filterOptionChange, dropdown, mobileSubmitButton}) {

    return (
        <div className="filter-group__filter-content">
            {filterGroup.filters.map((filter) => {
                return (
                    <FilterType
                        key={`filter_${filter.identifier}`}
                        filter={filter}
                        filterOptionChange={filterOptionChange}
                        dropdown={dropdown}
                        mobileSubmitButton={mobileSubmitButton}
                    />
                );
            })}
        </div>
    );
}

export default React.memo(FilterGroupContent)